interface RelatorioState {
  coops?: Array<string>;
  cpfOrNome?: string;
  colaborador?: boolean;
  data?: string;
  page: number;
  size: number;
}

type RelatorioActionTypes = 'setFiltros' | 'setPaginacao';

interface RelatorioAction {
  type: RelatorioActionTypes;
  value: any;
}

export const relatorioInitialState: RelatorioState = {
  page: 1,
  size: 10,
};

export const relatorioReducer = (
  state: RelatorioState,
  action: RelatorioAction
): RelatorioState => {
  switch (action.type) {
    case 'setFiltros':
      return { ...state, ...action.value, page: 1 };
    case 'setPaginacao':
      return { ...state, ...action.value };
    default:
      return state;
  }
};
